import { render } from "./Decoration.vue?vue&type=template&id=e5216e88&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"

import "./Decoration.vue?vue&type=style&index=0&id=e5216e88&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5216e88"]])

export default __exports__